import React from 'react';

import HighlightBadge from 'components/HighlightBadge';
import ActionCard from 'components/Common/Cards/ActionCard/ActionCard';
import { ReactComponent as AiIcon } from 'images/ai-stars-icon.svg';

import styles from './AISuggestionCard.module.scss';

interface AISuggestionCardProps {
  title: string;
  description: string;
  onClick?: () => void;
}

const AISuggestionCard: React.FC<AISuggestionCardProps> = ({ title, description, onClick }) => (
  <ActionCard onClick={onClick}>
    <HighlightBadge customText="Boost your goal!" />
    <div>
      <ActionCard.Title>{title}</ActionCard.Title>
      <ActionCard.Description>{description}</ActionCard.Description>
    </div>
    <ActionCard.Button onClick={onClick} className={styles.button}>
      <AiIcon />
      See how
    </ActionCard.Button>
  </ActionCard>
);

export default AISuggestionCard;
